module.exports = __webpack_public_path__ + "static/media/ia.a3760a8c.png";